(function ($) {
    $(document).ready(function () {

        const canvas = document.querySelector("#light-rays");
        if (!canvas) return; // Guard clause

        const context = canvas.getContext("2d", {alpha: true});

        function getRandomInt(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }

        const windowDimensions = {
            x: window.innerWidth,
            y: window.innerHeight
        };

        const source = {
            x: windowDimensions.x,
            y: -(windowDimensions.y * 0.75)
        };

        function handleCanvasDimension(x, y) {
            canvas.width = x;
            canvas.height = y;
        }

        // Debounce resize events
        let resizeTimeout;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                windowDimensions.x = window.innerWidth;
                windowDimensions.y = window.innerHeight;

                source.x = windowDimensions.x;
                source.y = -(windowDimensions.y * 0.75);

                handleCanvasDimension(windowDimensions.x, windowDimensions.y);

                // Recreate gradients on resize
                rays.forEach(ray => {
                    ray.gradient = context.createLinearGradient(source.x, source.y, ray.x, ray.y);
                });
            }, 150);
        });

        handleCanvasDimension(windowDimensions.x, windowDimensions.y);

        const counter = 25;
        const step = 0.01;
        const rays = [];

        function createRays() {
            const x = getRandomInt(-1920, 1920) * Math.random(),
                y = 1920 * Math.random() + 1024,
                gradient = context.createLinearGradient(source.x, source.y, x, y),
                width = Math.random() * 128;

            // Pre-configure gradient color stops
            gradient.addColorStop(0.5, "transparent");

            rays.push({
                x: x,
                y: y,
                width: width,
                fading: false,
                opacity: 0,
                threshold: Math.random(),
                gradient: gradient
            });
        }

        function updateRays(ray) {
            if (ray.opacity >= ray.threshold) {
                ray.fading = true;
            } else if (ray.opacity <= 0) {
                ray.fading = false;
            }

            ray.opacity += ray.fading ? -step : step;
        }

        function drawRays(ray) {
            // Skip rays that are invisible
            if (ray.opacity <= 0.001) return;

            context.beginPath();
            context.moveTo(source.x, source.y);
            context.lineTo(ray.x, ray.y);

            // Only update the first color stop
            ray.gradient.addColorStop(0, `rgba(128, 192, 255, ${ray.opacity})`);

            context.lineWidth = ray.width;
            context.strokeStyle = ray.gradient;
            context.stroke();
        }

        function init() {
            // Create all rays at once
            while (rays.length < counter) {
                createRays();
            }

            for (let i = 0; i < rays.length; i++) {
                updateRays(rays[i]);
                drawRays(rays[i]);
            }
        }

        let frameCount = 0;
        const frameSkip = 2; // Only animate every 3rd frame (reduce for more frequent updates)

        function animate() {
            frameCount++;

            if (frameCount % frameSkip === 0) {
                context.clearRect(0, 0, canvas.width, canvas.height);
                init();
            }

            requestAnimationFrame(animate);
        }

        animate();
    });
})(jQuery);
